let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("93Shw")).then(() => parcelRequire('2JOQ4'));